import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import './blog-detail.scss';
import SEO from '../../seo/SEO';

const timingsData = [
  {
    id: 1,
    title: 'Chaturdashi Starts',
    time: '24 Sep, 11:18 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 2,
    title: 'Chaturdashi Ends',
    time: '25 Sep, 11:06 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 3,
    title: 'Anant Puja Shubh Kaal',
    time: '06:11 AM - 12:24 PM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 4,
    title: 'Morning Visarjan (Char)',
    time: '06:11 AM - 07:42 AM',
    highlight: false,
    timeColor: 'dark',
  },
  {
    id: 5,
    title: 'Afternoon (Shubh/Labh)',
    time: '12:14 PM - 04:47 PM',
    highlight: false,
    timeColor: 'dark',
  },
];

const dossierData = [
  { key: 'Lunar Tithi', val: 'Bhadrapada Shukla Chaturdashi' },
  { key: 'Presiding Deities', val: 'Lord Ganesha & Lord Vishnu (Ananta)' },
  { key: 'Sacred Materials', val: 'Clay (Mitti), Durva, Turmeric Silk Thread' },
  { key: 'Primary Ritual', val: 'Visarjan & Ananta Vrata 14-Knot Sutra' },
  { key: 'Duration of Vow', val: '14 Consecutive Years' },
  { key: 'Upcoming Purnima', val: 'Bhadrapada Purnima (26 Sep 2026)' },
];

const ghatsData = [
  {
    id: 1,
    name: 'Girgaon Chowpatty, Mumbai',
    tag: 'Lalbaugcha Raja immersion hub',
    image: '/assets/blog/ghat-girgaon.png',
  },
  {
    id: 2,
    name: 'Juhu Beach, Mumbai',
    tag: 'Major western coastal processions',
    image: '/assets/blog/ghat-juhu.png',
  },
  {
    id: 3,
    name: 'Hussain Sagar, Hyderabad',
    tag: 'Khairatabad Ganesha immersion',
    image: '/assets/blog/ghat-hussain.png',
  },
];

const faqsData = [
  {
    id: 1,
    question: 'Q1. When is Anant Chaturdashi in 2026?',
    answer:
      'Anant Chaturdashi falls on Friday, 25 September 2026, with the Chaturdashi tithi running from 11:18 PM on 24 September to 11:06 PM on 25 September.',
  },
  {
    id: 2,
    question: 'Q2. When is Ganesh Visarjan 2026?',
    answer:
      'While Ganesh Visarjan can take place on various days depending on how long a household or community keeps their idol, the main Visarjan day in 2026 is Friday, 25 September, coinciding with Anant Chaturdashi.',
  },
  {
    id: 3,
    question: 'Q3. What is done on Anant Chaturdashi?',
    answer:
      'The day combines the major Ganesh Visarjan with the Ananta Vrata dedicated to Lord Vishnu, involving puja, the tying of the sacred Anant Sutra, and often a retelling of the Sushila and Kaundilya legend.',
  },
  {
    id: 4,
    question: 'Q4. What is the significance of the Anant Sutra?',
    answer:
      'The Anant Sutra is a sacred thread tied with fourteen knots, traditionally said to represent the fourteen realms of creation, worn on the right arm by men and the left arm by women as part of the Ananta Vrata.',
  },
  {
    id: 5,
    question: 'Q5. Why is Ganesh Visarjan performed on Anant Chaturdashi?',
    answer:
      'Anant Chaturdashi has traditionally served as the concluding day of the ten-day Ganeshotsav, so even households that kept their idol longer than a day or two tend to converge on this date for the final, largest round of immersions.',
  },
];

const interestedBlogs = [
  {
    id: 1,
    title: 'पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? जानिए पौराणिक कथा और श्राद्ध पूजा विधि',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
    link: '/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
  },
  {
    id: 2,
    title: "Why Is Kedarnath's Shivling Different?",
    image: '/assets/blog/interested-kedarnath.webp',
    link: '/blog/kedarnath-temple-history-and-pandava-story',
  },
  {
    id: 3,
    title: 'माता वैष्णो देवी की संपूर्ण कथा: भक्त श्रीधर और भैरवनाथ',
    image: '/assets/trending/vaishno-devi.webp',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
  },
];

export default function BlogDetail() {
  const [openFaq, setOpenFaq] = useState(1);
  const location = useLocation();

  const toggleFaq = (id) => {
    setOpenFaq((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title = 'Anant Chaturdashi 2026 - Date, Ganesh Visarjan, Puja & Significance | MandirWiki';
  }, [location.pathname]);

  return (
    <div className="blog-detail-page">
      {/* ========================================================
          1. HERO BANNER
      ======================================================== */}
      <SEO pageKey="blogAnantChaturdashi" />
      <section className="blog-detail-banner">
        <Container maxWidth="lg" className="banner-container">
          <Box className="banner-content">
            <h1 className="banner-title">
              Anant Chaturdashi 2026 <br />
              Date, Ganesh Visarjan, <br />
              Puja & Significance
            </h1>
          </Box>
        </Container>
      </section>

      {/* ========================================================
          2. MAIN CONTENT & SIDEBAR SECTION
      ======================================================== */}
      <section className="blog-body-section">
        <Container maxWidth="lg">
          <div className="blog-body-inner">
            {/* Breadcrumbs */}
            <nav className="blog-breadcrumbs" aria-label="breadcrumb">
            <Link to="/" className="breadcrumb-link">Home</Link>
            <span className="breadcrumb-separator">&gt;</span>
            <Link to="/blog" className="breadcrumb-link">Blog</Link>
            <span className="breadcrumb-separator">&gt;</span>
            <span className="breadcrumb-current">
              Anant Chaturdashi 2026 Date, Ganesh Visarjan, Puja &amp; Significance
            </span>
          </nav>

          {/* Two Column Grid */}
          <div className="blog-main-layout">
            {/* Left Column: Article Body */}
            <article className="blog-article-content">
              <h2 className="article-heading">When Ganpati Says Goodbye</h2>
              
              <p className="article-paragraph">
                By the tenth evening, the Ganpati idol that once stood freshly painted and garlanded on a raised platform looks different. The vermilion has dulled slightly under days of incense smoke, the flowers around the base have been replaced two or three times over, and the modaks offered each morning have left their faint, sweet trace in the air. Now the household gathers for the final aarti. Someone lights the camphor, the bells begin, and for a few minutes the room is entirely given over to the rhythm of the chant. Outside, drums are already warming up somewhere down the street, ready for the procession that will carry the idol to the water.
              </p>

              <p className="article-paragraph">
                This is Visarjan — the moment when the elaborate, joyful ten days of Ganeshotsav come to a close, and Ganpati is immersed with the words &ldquo;Ganapati Bappa Morya, Purchya Varshi Laukarya&rdquo; ringing through the crowd. In 2026, that final farewell falls on Friday, 25 September, which happens to carry a second layer of meaning. The same day is observed as Anant Chaturdashi, a festival dedicated not to Ganesha but to Lord Vishnu in his infinite, boundless form — Ananta. One evening, two very different threads of devotion, meeting at the same point on the lunar calendar. Understanding why takes a short detour through how Hindu festival dates are actually worked out.
              </p>

              <h2 className="article-heading">Why Is Anant Chaturdashi Associated With Ganesh Visarjan?</h2>

              {/* Inline Media Row: Sunset Visarjan Image + Text */}
              <div className="article-media-row">
                <div className="media-image-box">
                  <img
                    src="/assets/blog/visarjan-sunset.webp"
                    alt="Ganesh Visarjan at sunset"
                    className="media-image"
                    loading="lazy"
                  />
                </div>
                <div className="media-text-box">
                  <p className="article-paragraph">
                    The link between the two festivals is really a matter of timing rather than shared mythology. Ganeshotsav begins on Ganesh Chaturthi, and from there the household or community settles into its own rhythm of worship — daily aarti, offerings, visits from neighbours, and in many places, evening cultural programmes around the pandal. Some families keep their Ganpati for a day and a half, others for five days, and many for the full ten. Whatever the duration chosen, Anant Chaturdashi has traditionally functioned as the last and largest point on that calendar, the day by which even those who kept their idol the longest bring the festival to a close.
                  </p>
                  <p className="article-paragraph">
                    So while Visarjan itself can happen on several different days depending on personal or community practice, Anant Chaturdashi is the day when the collective farewell reaches its peak.
                  </p>
                </div>
              </div>

              {/* Ganesh Visarjan Rituals Section */}
              <h2 className="article-heading">
                Ganesh Visarjan 2026: Rituals, Processions &amp; Chants
              </h2>

              <p className="article-paragraph">
                The hours before immersion tend to follow a similar emotional arc wherever they happen, even if the specific practices differ from one home or mandal to the next. There&apos;s a final, more elaborate aarti than the daily ones that preceded it. Offerings are made one last time — flowers, durva grass, sweets — and some families take a moment to seek forgiveness for anything left undone or done imperfectly across the ten days, a small but meaningful part of the ritual that often gets overlooked in general descriptions of the festival.
              </p>

              <p className="article-paragraph">
                Then comes the procession. Idols large and small are lifted onto shoulders, carts, or decorated vehicles and carried, often at walking pace, towards a river, the sea, a lake, or increasingly, an artificial immersion pond set up by local authorities for environmental reasons. Drummers lead the way in many processions, dancers move alongside, and the chant rises and falls the whole route: &ldquo;Ganapati Bappa Morya, Purchya Varshi Laukarya&rdquo; — essentially, &ldquo;Come again next year.&rdquo; At the water&apos;s edge, there&apos;s usually a last round of prayers before the idol is immersed.
              </p>

              <p className="article-paragraph">
                The idea underlying all of this is fairly simple, even if it isn&apos;t often spelled out: the idol, made of clay or another biodegradable material in its traditional form, returns to the elements it came from. What doesn&apos;t go into the water is the devotion itself, which households carry forward until the next Ganesh Chaturthi comes around.
              </p>
            </article>

            {/* Right Column: Sidebar Cards */}
            <aside className="blog-sidebar">
              {/* Card 1: Auspicious Muhurat & Timings */}
              <div className="muhurat-widget-card">
                <div className="muhurat-header">
                  <div className="muhurat-header-title">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="clock-icon"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span>Auspicious Muhurat &amp; Timings</span>
                  </div>

                  <span className="muhurat-pill-badge">
                    <span className="dot" />
                    Open Today &bull; Main Visarjan Day
                  </span>
                </div>

                <div className="muhurat-body">
                  <div className="visarjan-day-meta">
                    Main Visarjan Day: <strong>Friday, 25 Sep 2026</strong>
                  </div>

                  <div className="timings-list">
                    {timingsData.map((item) => (
                      <div
                        key={item.id}
                        className={`timing-row ${item.highlight ? 'highlight-gold' : ''}`}
                      >
                        <span className="timing-label">{item.title}</span>
                        <span className={`timing-val color-${item.timeColor}`}>
                          {item.time}
                        </span>
                      </div>
                    ))}
                  </div>

                  <button type="button" className="book-puja-btn">
                    BOOK PUJA &amp; PANDIT SEVA
                  </button>

                  <p className="instant-booking-note">
                    Instant booking with certified Vedic Pandits
                  </p>
                </div>
              </div>

              {/* Card 2: Anant Chaturdashi Quick Dossier */}
              <div className="sidebar-card dossier-card">
                <div className="sidebar-card-header">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="header-icon"
                  >
                    <path d="M3 21h18M3 10h18M5 10v11M19 10v11M9 10v11M15 10v11M12 2l10 8H2l10-8z" />
                  </svg>
                  <h3 className="card-title">Anant Chaturdashi Quick Dossier</h3>
                </div>

                <div className="dossier-table">
                  {dossierData.map((row, idx) => (
                    <div key={idx} className="dossier-row">
                      <span className="dossier-key">{row.key}</span>
                      <span className="dossier-val">{row.val}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Card 3: Major Visarjan Ghats & Pandals */}
              <div className="sidebar-card ghats-card">
                <div className="sidebar-card-header">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="header-icon"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <polyline points="22 4 12 14.01 9 11.01" />
                  </svg>
                  <h3 className="card-title">Major Visarjan Ghats &amp; Pandals</h3>
                </div>

                <div className="ghats-list">
                  {ghatsData.map((item) => (
                    <div key={item.id} className="ghat-item">
                      <img src={item.image} alt={item.name} className="ghat-thumb" />
                      <div className="ghat-info">
                        <h4 className="ghat-name">{item.name}</h4>
                        <span className="ghat-tag">{item.tag}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Card 4: Free Offline Puja Vidhi & Aarti PDF */}
              <div className="sidebar-card pdf-card">
                <div className="sidebar-card-header">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="header-icon"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 12l4 4 4-4m-4-4v8" />
                  </svg>
                  <h3 className="card-title">Free Offline Puja Vidhi &amp; Aarti PDF</h3>
                </div>

                <p className="pdf-desc">
                  Comprehensive 16-page guide with step-by-step Visarjan vidhi, Anant Sutra chanting mantra, and Sanskrit aartis.
                </p>

                <button type="button" className="download-pdf-btn">
                  DOWNLOAD PDF (2.8 MB)
                </button>
              </div>
            </aside>
          </div>

          {/* ========================================================
              3. FULL GRID SECTION (Full Container Width Banner & Content)
          ======================================================== */}
          <div className="blog-full-grid-section">
            <div className="article-full-banner">
              <img
                src="/assets/blog/ganesh-visarjan-banner.webp"
                alt="Ganesh Visarjan 2026: Rituals, Processions & Chants"
                className="full-banner-img"
                loading="lazy"
              />
            </div>

            <div className="full-grid-content">
              <h2 className="article-heading">
                Anant Chaturdashi Puja: Worshipping Lord Vishnu
              </h2>

              <p className="article-paragraph">
                Once the public spectacle of Visarjan recedes a little, a quieter thread of the day comes into focus — the worship of Lord Vishnu as Ananta, a name that translates roughly to &ldquo;the endless&rdquo; or &ldquo;the one without limit.&rdquo; This observance centres on the Ananta Vrata, a vow traditionally undertaken for the protection, prosperity and general wellbeing of the family.
              </p>

              <p className="article-paragraph">
                The exact sequence of the puja tends to vary between households and regions, so it&apos;s worth describing the broad shape of it rather than a single fixed procedure. Many devotees begin by preparing a clean, dedicated space for worship, sometimes near a small pot of water representing Ananta, or an image of Vishnu reclining on the serpent Shesha. From there, the deity is worshipped with the usual elements of a Vrata — flowers, fruit, lamps, and other offerings appropriate to the household&apos;s own tradition. In many communities, this is also when the Sushila and Sage Kaundilya story is read aloud or recounted, since it&apos;s this legend that gives the day&apos;s central ritual object, the sacred thread, its meaning.
              </p>

              {/* Section 4: What Is the Anant Sutra? Meaning of the 14 Knots */}
              <h2 className="article-heading">
                What Is the Anant Sutra? Meaning of the 14 Knots
              </h2>

              <div className="article-full-banner">
                <img
                  src="/assets/blog/anant-sutra-banner.webp"
                  alt="What Is the Anant Sutra? Meaning of the 14 Knots"
                  className="full-banner-img"
                  loading="lazy"
                />
              </div>

              <p className="article-paragraph">
                Central to the Ananta Vrata is the Anant Sutra, a thread — often of cotton or silk, sometimes dyed with turmeric — tied with fourteen knots. Traditionally, these fourteen knots are understood to represent the fourteen realms or worlds (lokas) described in Hindu cosmology, linking the wearer symbolically to the full extent of creation over which Vishnu, in his infinite form, presides.
              </p>

              <p className="article-paragraph">
                Custom generally holds that the thread is tied around the right arm for men and the left arm for women, worn as both a mark of having observed the vow and a form of protection through the year ahead. As with much of this observance, the details can differ from one family or regional tradition to another, and it&apos;s worth treating this as a widely followed practice rather than a single uniform rule.
              </p>

              {/* Section 5: Ganesh Puja Before Visarjan */}
              <h2 className="article-heading">
                Ganesh Puja Before Visarjan
              </h2>

              <p className="article-paragraph">
                Before the idol ever leaves the house, there&apos;s a final round of worship dedicated purely to Ganesha, separate from the Ananta Vrata happening alongside it. Durva grass, considered one of Ganesha&apos;s favourite offerings, is placed at the idol&apos;s feet. Lamps are lit, modaks are offered one more time, and the household recites &ldquo;Om Gam Ganapataye Namah&rdquo;, one of the most commonly used mantras associated with the deity. It&apos;s in this moment, just before the idol is lifted for the procession, that many families pause to ask forgiveness for any shortcoming in the past ten days&apos; worship — a small gesture that quietly bridges the festival&apos;s exuberance and its farewell.
              </p>

              {/* Section 6: The Story Behind Anant Chaturdashi: Sushila & Sage Kaundilya */}
              <h2 className="article-heading">
                The Story Behind Anant Chaturdashi: Sushila &amp; Sage Kaundilya
              </h2>

              <p className="article-paragraph">
                The legend most commonly associated with the day concerns a woman named Sushila and her husband, the sage Kaundilya. According to the traditional story, Sushila once found a sacred thread tied by other women observing the Ananta Vrata and, on learning its significance, tied one herself, believing it would bring prosperity to her home. When Kaundilya later noticed the thread and, in irritation, cut it off without understanding its purpose, misfortune began to follow the couple.
              </p>

              <p className="article-paragraph">
                It was only after considerable hardship, and eventually meeting Lord Vishnu himself in the form of an old man, that Kaundilya learned the meaning behind the thread and the vow attached to it. Different retellings vary in their detail, but the story generally ends with the couple observing the Ananta Vrata properly and their fortunes being restored. It&apos;s this narrative, passed down in devotional retellings rather than a single canonical text, that continues to shape why the thread and the vrata are observed together on this day.
              </p>

              {/* Section 7: Media Row - Vyasa & Ganesha with Signify & Purnima content */}
              <div className="article-media-row vyasa-media-row">
                <div className="media-image-box">
                  <img
                    src="/assets/blog/vyasa-ganesha.webp"
                    alt="Sage Vyasa and Lord Ganesha writing"
                    className="media-image"
                    loading="lazy"
                  />
                </div>

                <div className="media-text-box">
                  <h2 className="article-heading">
                    What Does Anant Chaturdashi Signify?
                  </h2>

                  <p className="article-paragraph">
                    Strip away the ritual detail, and Anant Chaturdashi sits at an interesting meeting point of ideas. There&apos;s Ananta itself — the endless, unbounded nature attributed to Vishnu, invoked through a vow meant to last the observer through the year. Set against that is Visarjan, which is really about impermanence: a carefully crafted idol, worshipped intensely for ten days, deliberately returned to the water and allowed to dissolve. And running through both is the idea that devotion doesn&apos;t depend on the physical form remaining intact — the connection continues whether the idol is on the platform or in the river.
                  </p>

                  <p className="article-paragraph">
                    Taken together, the day marks a kind of transition: from the gathered, public energy of Ganeshotsav towards something quieter and more reflective, from celebration towards a farewell that isn&apos;t final so much as cyclical.
                  </p>

                  <h2 className="article-heading">
                    Anant Chaturdashi and Bhadrapada Purnima
                  </h2>

                  <p className="article-paragraph">
                    Anant Chaturdashi falls within the Hindu lunar month of Bhadrapada, on the fourteenth day of its waxing fortnight. A few days later, the month moves into its full moon, Bhadrapada Purnima, which is a separate observance in its own right and shouldn&apos;t be read as another name for Anant Chaturdashi. The two are simply close together on the same calendar — Chaturdashi marking the second-to-last lunar day of the fortnight, Purnima marking its completion.
                  </p>
                </div>
              </div>

              {/* Section 8: Conclusion (Full Width) */}
              <div className="article-conclusion-section">
                <h2 className="article-heading">
                  Conclusion: A Farewell That Leads to a Return
                </h2>

                <p className="article-paragraph">
                  By the time the last procession reaches the water on 25 September 2026, the day will have carried two festivals within it — one public and processional, the other quiet and thread-bound. The idol goes under the water, the drums fall quiet, and the crowd begins to disperse. What stays behind, in the words repeated at every immersion, is the promise embedded in the chant itself: Ganapati Bappa Morya, Purchya Varshi Laukarya. Not goodbye, then, so much as until next year.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>

      {/* FAQs Section */}
      <section className="blog-faqs-section">
        <Container maxWidth="lg">
          <h2 className="faqs-heading">FAQs</h2>
          <div className="faqs-accordion">
            {faqsData.map((faq) => {
              const isOpen = openFaq === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`faq-accordion-item ${isOpen ? 'active' : ''}`}
                >
                  <button
                    type="button"
                    className="faq-accordion-header"
                    onClick={() => toggleFaq(faq.id)}
                    aria-expanded={isOpen}
                  >
                    <span className="faq-question">{faq.question}</span>
                    <span className={`faq-icon ${isOpen ? 'open' : ''}`}>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </span>
                  </button>

                  <div className={`faq-accordion-collapse ${isOpen ? 'show' : ''}`}>
                    <div className="faq-accordion-body">
                      <p className="faq-answer">
                        <strong>Ans:</strong> {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>
      </section>

      {/* You Might Also Be Interested In This Section */}
      <section className="blog-interested-section">
        <Container maxWidth="lg">
          <h2 className="interested-heading">
            You Might Also Be Interested In This
          </h2>
          <div className="interested-grid">
            {interestedBlogs.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="interested-card"
              >
                <div className="card-thumb-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-thumb"
                    loading="lazy"
                  />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{item.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
